// extracted by mini-css-extract-plugin
module.exports = {"root":"ApplicationPage_root__1up5N","loading":"ApplicationPage_loading__KjSPV","error":"ApplicationPage_error__20zHE"};